export default __webpack_public_path__ + "static/media/move-material-8.50783512.webp";